import * as HotspotTargetType from "utils/HotspotTargetType";
import { createSelector } from "reselect";
import filter from "lodash/filter";
import makeGetChapterEntity from "selectors/chapter/makeGetChapterEntity";
import createCuepointBuckets from "utils/createCuepointBuckets";
import makeGetShowCuepoints from "selectors/cuepoint/makeGetShowCuepoints";
import makeGetChapterCuepoints from "./makeGetChapterCuepoints";

const getCuepointTargets = (state) => state.story.entities.cuepointTargets;

const getSliderWidth = (state, ownProps) => {
  if (ownProps.sliderWidth == null) {
    throw new TypeError("makeGetCuepointBuckets requires sliderWidth prop");
  }

  return ownProps.sliderWidth;
};

export default function makeGetCuepointBuckets() {
  const getChapterCuepoints = makeGetChapterCuepoints();
  const getChapter = makeGetChapterEntity();
  const getShowCuepoints = makeGetShowCuepoints();

  return createSelector(
    [
      getChapter,
      getChapterCuepoints,
      getCuepointTargets,
      getShowCuepoints,
      getSliderWidth,
    ],
    (
      chapter,
      chapterCuepoints,
      cuepointTargets,
      showCuepoints,
      sliderWidth,
    ) => {
      if (!showCuepoints) {
        return [];
      }

      const filteredCuepoints = filter(
        chapterCuepoints,
        (cuepoint) =>
          cuepointTargets[cuepoint.target].type !== HotspotTargetType.NONE,
      );

      return createCuepointBuckets({
        cuepoints: filteredCuepoints,
        chapterDuration: chapter.duration,
        sliderWidth,
      });
    },
  );
}
